export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
  case 'LAYERS_SET':
    return payload
  case 'LOGOUT':
    return []
  default:
    return state
  }
}
